import MapSvg from './MapSvg';
import MapPinSvg from './MapPinSvg';
import KeySvg from './KeySvg';
import MicSvg from './MicSvg';
import TagSvg from './TagSvg';
import NewSvg from './NewSvg';
import CopySvg from './CopySvg';
import MailSvg from './MailSvg';
import GiftSvg from './GiftSvg';
import UserSvg from './UserSvg';
import PlusSvg from './PlusSvg';
import CartSvg from './CartSvg';
import CheckSvg from './CheckSvg';
import HeartSvg from './HeartSvg';
import MinusSvg from './MinusSvg';
import CloseSvg from './CloseSvg';
import CameraSvg from './CameraSvg';
import NewBigSvg from './NewBigSvg';
import SearchSvg from './SearchSvg';
import EyeOffSvg from './EyeOffSvg';
import GoBackSvg from './GoBackSvg';
import GoogleSvg from './GoogleSvg';
import FilterSvg from './FilterSvg';
import ViewAllSvg from './ViewAllSvg';
import PlusBtnSvg from './PlusBtnSvg';
import HeartBigSvg from './HeartBigSvg';
import CalendarSvg from './CalendarSvg';
import DishPlusSvg from './DishPlusSvg';
import FacebookSvg from './FacebookSvg';
import DishMinusSvg from './DishMinusSvg';
import InputCheckSvg from './InputCheckSvg';
import CreditCardSvg from './CreditCardSvg';
import ArrowRightSvg from './ArrowRightSvg';
import SmartphoneSvg from './SmartphoneSvg';
import CodeAppliedSvg from './CodeAppliedSvg';
import TrashSvg from './TrashSvg';

export const svg = {
  KeySvg,
  NewSvg,
  MapSvg,
  MapPinSvg,
  MicSvg,
  TagSvg,
  GiftSvg,
  MailSvg,
  UserSvg,
  CopySvg,
  CartSvg,
  PlusSvg,
  CloseSvg,
  HeartSvg,
  MinusSvg,
  CheckSvg,
  EyeOffSvg,
  CameraSvg,
  GoBackSvg,
  FilterSvg,
  SearchSvg,
  NewBigSvg,
  GoogleSvg,
  ViewAllSvg,
  PlusBtnSvg,
  HeartBigSvg,
  CalendarSvg,
  DishPlusSvg,
  FacebookSvg,
  DishMinusSvg,
  InputCheckSvg,
  ArrowRightSvg,
  CreditCardSvg,
  SmartphoneSvg,
  CodeAppliedSvg,
  TrashSvg,
};
